import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { parseGroupsRecursive } from "./utils";
import { workerActions } from "../../slices/workers";
import { warehouseActions } from "../../slices/warehouse";

export const groupsRecursiveId = "groupsRecursive";
export const devicesDataId = "devices";
export const devicesListId = "devicesList";

const getGroupsRecursive = ({ server, cloner_key, group, controller }) => {
  console.log("getting group data!");
  const id = groupsRecursiveId;
  return async (dispatch) => {
    dispatch(workerActions.start(id));
    try {
      const url = server + "api/groups_recursive";
      const response = await axios.get(url, {
        signal: controller.signal,
        headers: { cloner_key },
        params: { group },
      });

      const parsedData = parseGroupsRecursive(response.data);

      dispatch(warehouseActions.load({ id: devicesDataId, data: parsedData }));
      const newDevices2 = parsedData.filter( x => !!x.mid).map(x => x.mid)
      dispatch(warehouseActions.load({id:devicesListId, data:newDevices2}))
      dispatch(workerActions.finish({ id }));
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id, error: e.message }));
      enqueueSnackbar(e.message, { variant: "error" });
    }
  };
};

export default getGroupsRecursive;
